<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardTicketTypeList.push"
    :is-show-search-input="true"
    search-placeholder="输入课次券名称进行搜索"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="课次券名称" prop="card_ticket_type_name"/>
    <el-table-column label="有效天数（天）">
      <template v-slot="{ row }">
        {{ row.expire_days | toYuan }} 天
      </template>
    </el-table-column>
    <el-table-column label="有效次数（次）">
      <template v-slot="{row}">
        {{ row.expire_number | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="原价（元）">
      <template v-slot="{ row }">{{ row.price_original | toYuan }}</template>
    </el-table-column>
    <el-table-column label="实际价格（元）">
      <template v-slot="{ row }">{{ row.price | toYuan }}</template>
    </el-table-column>
    <el-table-column width="220" label="购买范围">
      <template v-slot="{ row }">
        <span style="display: inline-flex; align-items: center; gap: 6px">
          <el-tag :type="findCardTicketPurchaseScope(row).tagType" size="small">{{ findCardTicketPurchaseScope(row).name }}</el-tag>
          <el-tag v-if="row.is_only_one" size="mini" type="warning">限持1张</el-tag>
        </span>
      </template>
    </el-table-column>

    <el-table-column label="小程序展示范围">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_test_only" type="warning">开发版或体验版</el-tag>
        <el-tag v-else-if="row.is_show_app" type="success">全部版本</el-tag>
        <el-tag v-else type="info">不在小程序展示</el-tag>
      </template>
    </el-table-column>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.cardTicketTypeEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此类型吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>


    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-type-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>课次券名称</span>
              <span>{{ v.card_ticket_type_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>有效天数（天）</span>
              <span>{{ v.expire_days | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>有效次数（次）</span>
              <span>{{ v.expire_number | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>原价（元）</span>
              <span>{{ v.price_original | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>实际价格（元）</span>
              <span>{{ v.price | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>购买范围</span>
              <span style="display: inline-flex; align-items: center; gap: 6px">
                <el-tag :type="findCardTicketPurchaseScope(v).tagType" size="small">{{ findCardTicketPurchaseScope(v).name }}</el-tag>
                <el-tag v-if="v.is_only_one" size="mini" type="warning">限持1张</el-tag>
              </span>
            </div>

            <div class="list-item-detail">
              <span>小程序展示范围</span>
              <el-tag v-if="v.is_test_only" type="warning">开发版或体验版</el-tag>
              <el-tag v-else-if="v.is_show_app" type="success">全部版本</el-tag>
              <el-tag v-else type="info">不在小程序展示</el-tag>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.cardTicketTypeEdit.to(v.id)"/>

              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要删除此类型吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/card-ticket-type';
import { findCardTicketPurchaseScope } from '@/enums/cardTicketPurchaseScopes';

export default {
  name: RouteConfig.cardTicketTypeList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findCardTicketPurchaseScope,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time }) {
      if (this.isDeleting[id]) return;
      if (!id) return this.$message.warning('缺少课次券类型 ID，无法删除！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.warning('缺少课次券类型信息，无法删除！');

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
